import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { AuthGuardService, AuthService } from '@rockwell-automation-inc/service';
import { HomeComponent } from './components/home/home.component';
import { LoggerService } from './services/logger.service';
import { AdminPortalRole, Permission } from './services/perm-helper.service';
import { PermGuard } from './shared/perm.guard';
import { RoleGuard } from './shared/role.guard';

@Component({ template: '' })
export class DummyComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  logger: LoggerService;
  constructor() {
    const logger = inject(LoggerService);
    this.logger = logger.withContext('DummyComponent');
  }
  ngOnInit(): void {
    this.authService.isAuthenticated$.subscribe((isAuth) => {
      if (!isAuth) {
        return;
      }

      const returnTo = this.route.snapshot.queryParams['returnTo'] || '/home';
      this.logger.log('authenticated; navigating to ', returnTo);
      this.router.navigateByUrl(returnTo);
    });
  }
}

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { component: HomeComponent, path: 'callback' },
  { component: DummyComponent, path: 'sign-in' },
  {
    canActivate: [AuthGuardService],
    loadComponent: (): Promise<any> => import('../app/components/home/home.component').then((m) => m.HomeComponent),
    path: 'home',
  },
  {
    canActivate: [AuthGuardService, PermGuard],
    data: {
      requiredPerms: {
        permissions: [Permission.ListTrialCampaign],
        operator: 'any',
      },
    },
    path: 'trials',
    loadChildren: (): Promise<any> =>
      import('../app/components/trials/trials-routing.module').then((m) => m.TRIALS_ROUTES),
  },
  {
    canActivate: [AuthGuardService, PermGuard],
    data: {
      requiredPerms: {
        permissions: [Permission.ListEntitlement],
      },
    },
    loadComponent: (): Promise<any> =>
      import('../app/components/entitlements/entitlements.component').then((m) => m.EntitlementsComponent),
    path: 'entitlement',
  },
  {
    canActivate: [AuthGuardService, PermGuard],
    data: {
      requiredPerms: { permissions: [Permission.ListUser], operator: 'any' },
    },
    path: 'users',
    loadChildren: (): Promise<any> =>
      import('../app/components/users/users-routing.module').then((m) => m.USERS_ROUTES),
  },
  {
    canActivate: [AuthGuardService, PermGuard],
    data: {
      requiredPerms: {
        permissions: [Permission.ListTenant],
        operator: 'any',
      },
    },
    path: 'organizations',
    loadChildren: (): Promise<any> =>
      import('../app/components/tenants/tenants-routing.module').then((m) => m.TENANTS_ROUTES),
  },
  {
    canActivate: [AuthGuardService, RoleGuard],
    data: {
      requiredRoles: {
        roles: [AdminPortalRole.RockwellAdmin],
      },
    },
    path: 'system-administration',
    loadChildren: (): Promise<any> =>
      import('../app/components/system-administration/system-administration-routing.module').then(
        (m) => m.SYSTEM_ADMINISTRATION_ROUTES,
      ),
  },
  { path: '**', redirectTo: '/home' },
];

export const appRoutes = routes;
